<template>
  <div>
    <div
      :class="[
        isMobileLayout ? 'about-container-main' : 'about-container-main',
      ]"
    >
      <div class="about-top">
        <el-image class="about-header" :src="images.headerImage.src" />
        <div class="about-top-content">
          <p>{{ headerTitleText }}</p>
        </div>
      </div>
      <MainLayout>
        <div class="container mt-50">
          <el-row class="theme-row">
            <el-col :lg="12" class="theme-col">
              <div class="text-left companuy-title">
                <h2 class="mb-20" v-html="leftTitleLabel" />
                <p class="mb-16" v-html="leftP1Text"></p>
                <p class="mb-16" v-html="leftP2Text"></p>
              </div>
            </el-col>
            <el-col :lg="12" class="theme-col">
              <div class="text-left">
                <h2 class="mb-20" v-html="rightTitleLabel" />
                <p class="mb-16" v-html="rightP1Text" />
                <p class="mb-16" v-html="rightP2Text" />
                <p class="mb-16" v-html="rightP3Text" />
              </div>
            </el-col>
          </el-row>
        </div>
      </MainLayout>
      <div class="about-section-2 mt-50 mb-50 pt-50 pb-50">
        <div class="container about-container">
          <div class="contact-cta text-center mb-50">
            <h2 class="mb-20">{{ contactCta.title }}</h2>
            <p v-if="contactCta.body" class="mb-20">{{ contactCta.body }}</p>
            <el-button
              class="about-submit-btn"
              type="primary"
              @click="goTo('/contact-us')"
            >
              {{ contactCta.button }}
            </el-button>
          </div>
          <el-row class="theme-row addresses-row">
            <el-col :lg="12" class="theme-col">
              <div class="address-block text-left">
                <p class="mb-6 fs-14">{{ address1Title }}</p>
                <p class="fw-500" v-html="$t('aboutUs.address1.desc')" />
              </div>
            </el-col>
            <el-col :lg="12" class="theme-col">
              <div class="address-block text-left">
                <p class="mb-6 fs-14">{{ address3Title }}</p>
                <p class="fw-500" v-html="$t('aboutUs.address3.desc')" />
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MainLayout from "@/components/layout/main-layout.vue";
import layoutUtils from "@/utils/layout-utils";
import aboutUsDefaultImage from "@/assets/images/about-us/about-us.jpg";
import goTo from "@/mixins/goTo";
import { aboutContactCta } from "@/content/public-pages-content";
import { normalizeLocale } from "@/utils/market-utils";

export default {
  mixins: [goTo],
  components: {
    MainLayout,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
    puid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      quantityForm: {
        quantity: 0,
      },
      images: {
        headerImage: {
          src: aboutUsDefaultImage,
        },
      },
    };
  },
  computed: {
    ...mapState("configuration", ["actionBar"]),
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    localeKey() {
      return normalizeLocale(this.$i18n.locale);
    },
    contactCta() {
      return aboutContactCta[this.localeKey];
    },
    headerTitleText() {
      return this.$i18n.t("aboutUs.header.title");
    },
    leftTitleLabel() {
      return this.$i18n.t("aboutUs.left.title");
    },
    leftP1Text() {
      return this.$i18n.t("aboutUs.left.p1");
    },
    leftP2Text() {
      return this.$i18n.t("aboutUs.left.p2");
    },
    rightTitleLabel() {
      return this.$i18n.t("aboutUs.right.title");
    },
    rightP1Text() {
      return this.$i18n.t("aboutUs.right.p1");
    },
    rightP2Text() {
      return this.$i18n.t("aboutUs.right.p2");
    },
    rightP3Text() {
      return this.$i18n.t("aboutUs.right.p3");
    },
    contactUsTitle() {
      return this.$i18n.t("aboutUs.contactUs.title");
    },
    contactUsFirst() {
      return this.$i18n.t("aboutUs.contactUs.first");
    },
    contactUsLast() {
      return this.$i18n.t("aboutUs.contactUs.last");
    },
    contactUseEmail() {
      return this.$i18n.t("aboutUs.contactUs.email");
    },
    contactUseSubject() {
      return this.$i18n.t("aboutUs.contactUs.subject");
    },
    address1Title() {
      return this.$i18n.t("aboutUs.address1.title");
    },
    address2Title() {
      return this.$i18n.t("aboutUs.address2.title");
    },
    address3Title() {
      return this.$i18n.t("aboutUs.address3.title");
    },
    address1Desc() {
      return this.$i18n.t("aboutUs.address1.desc");
    },
    address2Desc() {
      return this.$i18n.t("aboutUs.address2.desc");
    },
    address3Desc() {
      return this.$i18n.t("aboutUs.address3.desc");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
$logo-dimension: 16px;
.about-container-main {
  margin: 0 100px;
  // sm -
  @media screen and (max-width: $media-md) {
    margin: 0 20px;
  }
}
.about-top {
  position: relative;
  margin: 20px auto 0;
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    max-width: $container-max-width-md;
  }
  @media screen and (min-width: $media-lg) {
    max-width: $container-max-width-lg;
  }
}
.about-top .about-top-content {
  position: absolute;
  bottom: 20px;
  z-index: 1;
  background: #ffffffbd;
  color: #000000;
  padding: 30px 20px;
  right: 10%;
  left: 50%; 
  p {
    font-size: 14px;
  }
}
.about-header {
  width: 100%;
}
.about-section-2 {
  background: #dddddd;
  padding-left: 15px;
  padding-right: 15px;
}
.theme-row {
  margin-left: -15px;
  margin-right: -15px;
}
.theme-col {
  padding-left: 15px;
  padding-right: 15px;
}
.fw-500 {
  font-weight: 500;
}
.fs-14 {
  font-size: 14px;
}
.contact-cta h2 {
  margin-top: 0;
}
.addresses-row {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  padding-top: 30px;
}
.addresses-row .address-block {
  padding-left: 15px;
  padding-right: 15px;
}
.addresses-row .el-col + .el-col .address-block {
  border-left: 1px solid #000000;
  padding-left: 30px;
}

@media only screen and (max-width: 1199px) {
  .about-section-2 {
    padding-left: 15px;
    padding-right: 15px;
  }
  .addresses-row .el-col + .el-col .address-block {
    border-left: none;
    padding-left: 15px;
    margin-top: 30px;
  }
  .about-container {
    min-width: auto;
  }
  .about-top .about-top-content {
    left: 20px;
    right: 20px;
    bottom: 20px;
  }
}

@media screen and (max-width: $media-md) {
  .about-top .about-top-content {
    position: static;
    left: auto;
    right: auto;
    bottom: auto;
    padding: 20px;
    background: #ffffffbd;
  }
}
.about-submit-btn {
  width: auto;
  padding-left: 24px;
  padding-right: 24px;
}
.companuy-title {
  color: rgb(39, 36, 33);
}
</style>
